import Loader from "../../common/components/Loader";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import { useGetYearlyCommunityTrendAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import CountCard from "../../common/components/CountCard";
import { Bar } from "react-chartjs-2";
import { formatDate } from "../../../utilities/format";

const getCharLabels = () => {
  const today = new Date();

  return Array.from({ length: 12 }).map((_, index) => {
    const date = new Date(
      today.getFullYear(),
      today.getMonth() - 11 + index,
      1
    );

    return formatDate(date.toISOString(), "YY년 MM월");
  });
};

export default function CommunityStats() {
  const { data, loading } = useGetYearlyCommunityTrendAsAdminQuery();

  if (loading) {
    return (
      <BoxWithShadow className="h-[700px] min-h-[700px]">
        <Loader />
      </BoxWithShadow>
    );
  }

  const trends = data?.getYearlyCommunityTrendAsAdmin || [];
  const labels = getCharLabels();

  const allCounts =
    trends?.flatMap((trend) => [trend?.general || 0, trend?.secret || 0]) || [];
  const maxY = Math.max(...allCounts, 0);

  return (
    <BoxWithShadow className="h-[700px] min-h-[700px] p-0">
      <div className="flex h-full gap-5">
        <div className="flex w-1/6 flex-shrink-0 flex-col items-start gap-1 py-5 ps-3">
          <p className="text-lg font-bold">이번달 게시물 현황</p>
          <div className="grid h-full w-full grid-rows-4 gap-1">
            <CountCard
              label="일반주제"
              count={trends?.at(-1)?.general}
              unit="개"
            />
            <CountCard
              label="대나무숲"
              count={trends?.at(-1)?.secret}
              unit="개"
            />
          </div>
        </div>
        <div className="flex h-full w-full flex-col gap-3 py-5 pe-3">
          <p className="text-lg font-bold">1년 게시물 현황</p>
          <div className="h-full">
            <Bar
              id="community-stats-chart"
              style={{
                width: "100%",
                height: "100%",
              }}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: "bottom",
                  },
                },
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                    ticks: {
                      color: "#666",
                    },
                  },
                  y: {
                    ticks: {
                      stepSize: 20,
                      color: "#666",
                    },
                    beginAtZero: true,
                    max: maxY,
                  },
                },
              }}
              data={{
                labels,
                datasets: [
                  {
                    label: "일반주제",
                    data: trends?.map((trend) => trend?.general),
                    backgroundColor: "#894343",
                  },
                  {
                    label: "대나무숲",
                    data: trends?.map((trend) => trend?.secret),
                    backgroundColor: "#438943",
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>
    </BoxWithShadow>
  );
}
